<template>
  <div class="row">
    <card
      type="tasks"
      class="col-sm"
      style="height: auto; padding-bottom: 30px; overflow-x: auto"
    >
      <template slot="header">
        <div style="">
          <div class="row">
            <div class="">
              <h4 class="title d-inline">黑名单</h4>
            </div>
          </div>
        </div>
        <div style="margin-top: 20px">
          <div>
            <div
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <el-select
                class="select-primary mb-3 pagination-select"
                v-model="pagination.perPage"
                placeholder="Per page"
              >
                <el-option
                  class="select-primary"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                >
                </el-option>
              </el-select>

              <base-input>
                <el-input
                 style="width:230px"
                  @blur="onBlur"
                  type="search"
                  class="mb-3 search-input"
                  prefix-icon="el-icon-search"
                  placeholder="搜索账号或拉黑内容"
                  v-model="searchQuery"
                  aria-controls="datatables"
                >
                </el-input>
              </base-input>
            </div>
            <el-table :data="queriedData">
              <el-table-column label="id" prop="id" :min-width="80">
              </el-table-column>
              <el-table-column label="黑名单用户CDK" prop="cdk" :min-width="280">
              </el-table-column>

              <el-table-column
                label="黑名单拉黑内容"
                prop="data"
                :min-width="150"
              >
              </el-table-column>
              <el-table-column
                label="黑名单备注"
                prop="risk_desc"
                :min-width="350"
              >
              </el-table-column>

              <el-table-column
                label="添加时间"
                prop="add_time"
                :min-width="170"
                :formatter="timeFormatter"
              >
              </el-table-column>

              <el-table-column
                label="删除黑名单"
                prop="state"
                :min-width="100"
                align="center"
              >
                <template slot-scope="{ row }">
                  <base-button
                  type="danger"
                  style="margin-left: 6px"
                  size="sm"
                  icon
                  @click="delBlack(row.id)"
                >
                  <i
                    style="color: #ffffff"
                    class="tim-icons icon-simple-remove"
                  ></i>
                </base-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div
            slot="footer"
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <div class="">
              <p class="card-category">
                显示 {{ from + 1 }} 到 {{ to }} 总数 {{ total }} 条
              </p>
            </div>
            <base-pagination
              class="pagination-no-border"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
            >
            </base-pagination>
          </div>
        </div>
      </template>
    </card>

  </div>
</template>

<script>
import { Table, TableColumn, Select, Option } from "element-ui";
import { BasePagination } from "../../components";
import Swal from "sweetalert2";
import { http } from "../../util/http.js";
import { changeDateFormat, checkTime } from "../../util/utils.js";
import Badge from "@/components/Badge";
import Modal from "@/components/Modal";
import BaseTable from "@/components/BaseTable";

export default {
  components: {
    // BaseTable,
    // Modal,
    Badge,
    BasePagination,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  computed: {
    queriedData() {
      return this.tableData;
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.pagination.total;
    },
  },
  data() {
    return {
      checkTime,
      changeDateFormat,
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      searchQuery: "",
      blurredSearchQuery: "",
      propsToSearch: ["cdk", "email", "age"],
      tableData: [],
      searchedData: [],
      fuseSearch: null,
      modals1: false,
      packageTableData: [],
      packageColumns: [
        "id",
        "package_name",
        "site_name",
        "package_type",
        "download_num",
        "start_time",
        "end_time",
      ],
      cdkTableData: [],
      cdkColumns: [
        "id",
        "cdk",
        "package_name",
        "package_type",
        "use_time",
        "add_time",
        "state",
        "admin_username",
      ],
      payTableData: [],
      payColumns: [
        "id",
        "package_name",
        "order_no",
        "trade_no",
        "pay_ip",
        "create_time",
        "pay_time",
        "pay_type",
        "pay_state",
      ],
    };
  },
  methods: {
    hangleQuery(id) {
      http
        .post(
          "/v1/admin/getAllDownload",
          {
            userId: id,
          },
          { headers: { adminToken: localStorage.getItem("adminToken") } }
        )
        .then((res) => {
          if (res.data.code != 200) {
            this.$notify({
              type: "danger",
              message: res.data.message,
              timeout: 3000,
              icon: "tim-icons icon-bell-55",
            });
            return;
          }
          this.$notify({
            type: "success",
            message: res.data.message,
            timeout: 3000,
            icon: "tim-icons icon-bell-55",
          });
          this.packageTableData = res.data.data.packageInfo;
          this.cdkTableData = res.data.data.cdkInfo;
          this.payTableData = res.data.data.payInfo;
          this.modals1 = true;
        })
        .catch((error) => {
          console.error("发生错误:", error);
        });
    },
    handleQueryUser(username) {
      this.$router.push({ path: "/user", query: { username: username } });
    },
    delBlack(id) {
      http
        .post(
          "/v1/admin/delBlackData",
          {
            blackId: id,
          },
          { headers: { adminToken: localStorage.getItem("adminToken") } }
        )
        .then((res) => {
          if (res.data.code != 200) {
            Swal.fire({
              icon: "error",
              title: "删除失败",
              text: res.data.message,
              customClass: {
                confirmButton: "btn btn-success btn-fill",
              },
              buttonsStyling: false,
            });
            return;
          }
          this.handleCurrentChange();
          Swal.fire({
            icon: "success",
            title: "删除成功",
            text: res.data.message,
            customClass: {
              confirmButton: "btn btn-success btn-fill",
            },
            buttonsStyling: false,
          });
        })
        .catch((error) => {
          console.error("发生错误:", error);
          // 或者将错误状态存储到Vue组件中的数据中，并在页面上显示友好的提示
        });
    },
    onBlur() {
      if (this.searchQuery == "") {
        this.handleCurrentChange();
      }
      // 当输入框失去焦点时，改变 blurredSearchQuery 的值
      this.blurredSearchQuery = this.searchQuery;
    },
    handleCurrentChange() {
      http
        .post(
          "/v1/admin/getAllBlack",
          {
            currentPage: this.pagination.currentPage,
            perPage: this.pagination.perPage,
            searchQuery: this.searchQuery,
          },
          { headers: { adminToken: localStorage.getItem("adminToken") } }
        )
        .then((res) => {
          if (res.data.code != 200) {
            this.$notify({
              type: "danger",
              message: res.data.message,
              timeout: 2000,
              icon: "tim-icons icon-bell-55",
            });
            return;
          }
          this.pagination.total = res.data.data.total;
          this.tableData = res.data.data.tableData;
        })
        .catch((error) => {
          console.error("发生错误:", error);
        });
    },
    timeFormatter(row, column, cellValue) {
      // 在这里处理你的数据
      // row 是整个行数据
      // column 是列数据
      // cellValue 是单元格的值
      // 例如你想将名字转为大写形式：
      if (cellValue == "0001-01-01T00:00:00Z") {
        return "";
      } else {
        cellValue = changeDateFormat(cellValue);
        return cellValue;
      }
    },
    // 清除查询条件
    clearSearchQuery() {
      // this.searchQuery = "";
    },
  },
  mounted() {
    // 页面跳转参数接收
    // 获取 URL 中的 query 参数
    const username = this.$route.query.username;

    if (username) {
      this.searchQuery = username; // 如果有 username 参数，设置为查询条件
      this.handleCurrentChange();
    } else {
      // 如果没有 username 参数，清空 searchQuery
      this.searchQuery = "";
      // this.clearSearchQuery();
      // 立即查询用户信息
      this.handleCurrentChange();
    }
    // 清除 URL 中的查询参数
    if (this.$route.query.username) {
      this.$router.replace({ path: "/user" }); // 这里不携带任何查询参数
    }
  },

  watch: {
    blurredSearchQuery(newVal, oldVal) {
      // 监控搜索
      if (newVal == "") {
        // this.handleCurrentChange();
        return;
      }
      this.handleCurrentChange();
    },
    "pagination.currentPage"(newPage, oldPage) {
      // 监控翻页
      // 这里进行你的数据请求等操作
      this.handleCurrentChange();
    },
    "pagination.perPage"(newPage, oldPage) {
      // 监控翻页
      // 这里进行你的数据请求等操作
      this.handleCurrentChange();
    },
  },
};
</script>
<style scoped lang="scss" >
.pagination-select,
.search-input {
  width: 200px;
}
::v-deep .modal-dialog {
  max-width: 1500px !important;
}
</style>
